export default "precision mediump float;\n#define GLSLIFY 1\nvarying vec4 v_Color;\nvoid main() {\n    gl_FragColor = v_Color;\n}";